import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { pinService } from '../services/pinService';
import './PinEntryPage.css';

const PinEntryPage: React.FC = () => {
  const [pin, setPin] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await pinService.verifyPin(pin);
      // Navigate to presentation mode
      navigate('/present', { replace: true });
    } catch (err: any) {
      setError(err.message || 'Invalid PIN');
      setPin(''); // Clear PIN on error
    } finally {
      setLoading(false);
    }
  };

  const handlePinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Only allow digits, max 6 characters
    const value = e.target.value.replace(/\D/g, '').slice(0, 6);
    setPin(value);
  };

  return (
    <div className="pin-entry-page">
      <div className="pin-container">
        <h1>Presentation Access</h1>
        <p className="subtitle">Enter 6-Digit PIN</p>

        {error && (
          <div className="alert alert-error">
            <strong>Error:</strong> {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="pin-form">
          <div className="pin-input-group">
            <input
              type="text"
              value={pin}
              onChange={handlePinChange}
              placeholder="••••••"
              className="pin-input"
              maxLength={6}
              pattern="[0-9]{6}"
              required
              disabled={loading}
              autoFocus
            />
          </div>

          <button 
            type="submit" 
            className="btn btn-primary" 
            disabled={loading || pin.length !== 6}
          >
            {loading ? 'Verifying...' : 'Enter Presentation'}
          </button>
        </form>

        <div className="pin-info">
          <p>
            The presentation PIN is required to access the full-screen presentation mode.
            Contact your administrator if you don't have the PIN.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PinEntryPage;
